import {defineStore} from 'pinia';
import {ModuleDepartment} from '../moduleConst';
import {BaseDictionaryStore} from '../baseDictionaryStore';
import departmentAPI from '@/apis/di/departmentAPI';

const departmentStore = new BaseDictionaryStore(departmentAPI);

export const useDepartmentStore = defineStore(ModuleDepartment, {
  state: () => ({
    ...departmentStore.state,
    _config: {
      key: 'department_id',
      code: 'department_code',
      name: 'department_name',
      table: 'di_department',
      moduleName: 'Phòng ban',
      quickFollow: 'active',
      isTree: true,
      defaultSort: 'department_code',
    },
    moduleName: 'department',
  }),
  actions: {...departmentStore.action},
  getters: {
    ...departmentStore.getters,
  },
});
